// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconAusdt0 } from "../../../icons/mono/build/icon-ausdt0.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const AusdtZeroIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconAusdt0.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  AusdtZeroIcon.displayName = 'AusdtZeroIcon';
}

export default AusdtZeroIcon;